import React from "react";
import Hiro from "./Hiro";
import CTA from "./CTA";
import CTA_2 from "./CTA_2";
import Steps from "./Steps";
import FAQ from "./FAQ";
import AppointmentForm from "./AppointmentForm";
import ServicesSection from "./ServicesSection";
import Banner from "./Banner";
import MapSection from "./MapSection";
import BenefitsSection from "./BenefitsSection";
import EvidensSection from"./EvidensSection";
import CTA3 from"./CTA3";
import GetHandyman from"./GetHandyman";
import About from "./About";

function Home(props) {
  return (
    <div>
      
      <Hiro />
      <Banner />
      <AppointmentForm />
      {/* <ServicesSection /> */}
      <CTA />
      <MapSection /> 
      <BenefitsSection />
      <About />
      <FAQ />
      <CTA_2 />
      {/* <GetHandyman /> */}
      {/* <EvidensSection /> */}
      {/* <CTA3 /> */}
      
    </div>
  );
}

export default Home;
